import { LitElement, html, css, styles } from '@hh/global.js'

class InlineFacet extends LitElement {
  static properties = {
    _activeFacets: {
      state: true,
      type: Array,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  onChange(e) {
    const { value, checked } = e.target
    this.dispatchEvent(
      new CustomEvent('facet-change', {
        bubbles: true,
        composed: true,
        detail: { value, checked },
      })
    )
  }

  render() {
    return html`
      <li class="facet">
        <input
          class="visually-hidden"
          type="checkbox"
          id="${this.filter.handle}-${this.index}"
          name="${this.filter.param_name}"
          value="${this.facet.value}"
          @change=${this.onChange}
          .checked=${this._activeFacets.includes(this.facet.value)}
        />
        <label for="${this.filter.handle}-${this.index}"
          >${this.facet.label}</label
        >
      </li>
    `
  }

  static styles = [
    styles.visuallyHidden,
    css`
      .facet label {
        font: var(--hh-body-utility);
        letter-spacing: 0.1em;
        text-transform: uppercase;
        padding: 0.6rem 1rem;
        user-select: none;
        cursor: pointer;
        border: 1px solid var(--hh-color-foreground);
        transition: background-color var(--hh-duration-default) ease-in-out;
      }

      .facet input {
        touch-action: none;
      }

      .facet input:is(:checked, :focus-visible) + label {
        color: var(--hh-color-background);
        background-color: var(--hh-color-foreground);
      }

      @media (hover: hover) {
        .facet input:hover + label {
          color: var(--hh-color-background);
          background-color: var(--hh-color-foreground);
        }
      }

      .facet input:focus-visible + label {
        outline: 0.2rem solid var(--hh-color-focus);
      }

      .facet input:disabled + label {
        pointer-events: none;
      }
    `,
  ]
}

customElements.define('hh-inline-facet', InlineFacet)

class InlineFacetReset extends InlineFacet {
  onFacetReset(e) {
    const { value, checked } = e.target
    this.dispatchEvent(
      new CustomEvent('facet-reset', {
        bubbles: true,
        composed: true,
        detail: { value, checked },
      })
    )
  }

  render() {
    return html`
      <li class="facet">
        <input
          class="visually-hidden"
          type="checkbox"
          id="all"
          name="all"
          value="all"
          @click=${this.onFacetReset}
          .checked=${this._activeFacets.length === 0}
        />
        <label for="all">${this.tAll}</label>
      </li>
    `
  }
}

customElements.define('hh-inline-facet-reset', InlineFacetReset)
